// extracted by mini-css-extract-plugin
export var BODY_TEXT_EXTRA_LARGE = "ButtonV2-module--BODY_TEXT_EXTRA_LARGE--j5vHJ";
export var BODY_TEXT_EXTRA_SMALL = "ButtonV2-module--BODY_TEXT_EXTRA_SMALL--FUWfU";
export var BODY_TEXT_LARGE = "ButtonV2-module--BODY_TEXT_LARGE--v0enX";
export var BODY_TEXT_LARGE_V2 = "ButtonV2-module--BODY_TEXT_LARGE_V2--zALA8";
export var BODY_TEXT_MEDIUM = "ButtonV2-module--BODY_TEXT_MEDIUM--SXWBa";
export var BODY_TEXT_MEDIUM_V1 = "ButtonV2-module--BODY_TEXT_MEDIUM_V1--EmBAx";
export var BODY_TEXT_SMALL = "ButtonV2-module--BODY_TEXT_SMALL--VD1Hs";
export var BOLD = "ButtonV2-module--BOLD--6M9ln";
export var COMMON = "ButtonV2-module--COMMON--+mKCW";
export var FONT_FIGTREE = "ButtonV2-module--FONT_FIGTREE--loupE";
export var HEADING = "ButtonV2-module--HEADING--YcIcq";
export var HEADING_1 = "ButtonV2-module--HEADING_1--MiGet";
export var HEADING_1_V1 = "ButtonV2-module--HEADING_1_V1--xRGgL";
export var HEADING_2 = "ButtonV2-module--HEADING_2--TeJ1M";
export var HEADING_2_V2 = "ButtonV2-module--HEADING_2_V2--hqurn";
export var HEADING_3 = "ButtonV2-module--HEADING_3--bKeYe";
export var HEADING_4 = "ButtonV2-module--HEADING_4--WTkZG";
export var HEADING_4_V2 = "ButtonV2-module--HEADING_4_V2--BwJP8";
export var HEADING_5 = "ButtonV2-module--HEADING_5--knOF3";
export var HEADING_5_V2 = "ButtonV2-module--HEADING_5_V2--KQpRU";
export var HEADING_GENERALSANS = "ButtonV2-module--HEADING_GENERALSANS--x56Y8";
export var MEDIUM = "ButtonV2-module--MEDIUM--sV0tY";
export var MOBILE_BODY_TEXT_EXTRA_LARGE = "ButtonV2-module--MOBILE_BODY_TEXT_EXTRA_LARGE--wzvna";
export var MOBILE_BODY_TEXT_EXTRA_SMALL = "ButtonV2-module--MOBILE_BODY_TEXT_EXTRA_SMALL--L6V7U";
export var MOBILE_BODY_TEXT_LARGE = "ButtonV2-module--MOBILE_BODY_TEXT_LARGE--S6z8O";
export var MOBILE_BODY_TEXT_LARGE_V2 = "ButtonV2-module--MOBILE_BODY_TEXT_LARGE_V2--D6eX0";
export var MOBILE_BODY_TEXT_MEDIUM = "ButtonV2-module--MOBILE_BODY_TEXT_MEDIUM--BWzvW";
export var MOBILE_BODY_TEXT_MEDIUM_V1 = "ButtonV2-module--MOBILE_BODY_TEXT_MEDIUM_V1--H+yiL";
export var MOBILE_BODY_TEXT_SMALL = "ButtonV2-module--MOBILE_BODY_TEXT_SMALL--yyqDW";
export var MOBILE_HEADING_1 = "ButtonV2-module--MOBILE_HEADING_1--NeZmn";
export var MOBILE_HEADING_1_V1 = "ButtonV2-module--MOBILE_HEADING_1_V1--QNyhN";
export var MOBILE_HEADING_2 = "ButtonV2-module--MOBILE_HEADING_2--XyxtQ";
export var MOBILE_HEADING_2_V2 = "ButtonV2-module--MOBILE_HEADING_2_V2--SGWkN";
export var MOBILE_HEADING_3 = "ButtonV2-module--MOBILE_HEADING_3--8dN5x";
export var MOBILE_HEADING_4 = "ButtonV2-module--MOBILE_HEADING_4--UYa47";
export var MOBILE_HEADING_4_V2 = "ButtonV2-module--MOBILE_HEADING_4_V2--JW7dJ";
export var MOBILE_HEADING_5 = "ButtonV2-module--MOBILE_HEADING_5--IQklT";
export var MOBILE_HEADING_5_V2 = "ButtonV2-module--MOBILE_HEADING_5_V2--HhmNV";
export var REGULAR = "ButtonV2-module--REGULAR--ZpXB4";
export var SEMIBOLD = "ButtonV2-module--SEMIBOLD--H6fdO";
export var TABLET_BODY_TEXT_EXTRA_LARGE = "ButtonV2-module--TABLET_BODY_TEXT_EXTRA_LARGE--lNA+z";
export var TABLET_BODY_TEXT_EXTRA_SMALL = "ButtonV2-module--TABLET_BODY_TEXT_EXTRA_SMALL--xe3xM";
export var TABLET_BODY_TEXT_LARGE = "ButtonV2-module--TABLET_BODY_TEXT_LARGE--BffSK";
export var TABLET_BODY_TEXT_LARGE_V2 = "ButtonV2-module--TABLET_BODY_TEXT_LARGE_V2--MYBRB";
export var TABLET_BODY_TEXT_MEDIUM = "ButtonV2-module--TABLET_BODY_TEXT_MEDIUM--sb9Yo";
export var TABLET_BODY_TEXT_MEDIUM_V1 = "ButtonV2-module--TABLET_BODY_TEXT_MEDIUM_V1--o-its";
export var TABLET_BODY_TEXT_SMALL = "ButtonV2-module--TABLET_BODY_TEXT_SMALL--zfbIW";
export var TABLET_HEADING_1 = "ButtonV2-module--TABLET_HEADING_1--N0X0Y";
export var TABLET_HEADING_1_V1 = "ButtonV2-module--TABLET_HEADING_1_V1--VX854";
export var TABLET_HEADING_2 = "ButtonV2-module--TABLET_HEADING_2--kdc4B";
export var TABLET_HEADING_2_V2 = "ButtonV2-module--TABLET_HEADING_2_V2--kumAp";
export var TABLET_HEADING_3 = "ButtonV2-module--TABLET_HEADING_3--7G09t";
export var TABLET_HEADING_4 = "ButtonV2-module--TABLET_HEADING_4--hGn4X";
export var TABLET_HEADING_4_V2 = "ButtonV2-module--TABLET_HEADING_4_V2--i4OlL";
export var TABLET_HEADING_5 = "ButtonV2-module--TABLET_HEADING_5--c9F-U";
export var TABLET_HEADING_5_V2 = "ButtonV2-module--TABLET_HEADING_5_V2--YdQKt";
export var button = "ButtonV2-module--button--zo0Y5";
export var center = "ButtonV2-module--center--r1qYr";
export var disabled = "ButtonV2-module--disabled--1hKPE";
export var learnMoreDefaultPadding = "ButtonV2-module--learnMoreDefaultPadding--2ggfF";
export var limitWidthOnLargeScreens = "ButtonV2-module--limitWidthOnLargeScreens--JjZJS";
export var link = "ButtonV2-module--link--SCRI6";
export var mobileWidth = "ButtonV2-module--mobileWidth--vZExY";
export var secondary = "ButtonV2-module--secondary--Xs46w";
export var tabletFullWidth = "ButtonV2-module--tabletFullWidth--GtKeS";
export var v2 = "ButtonV2-module--v2--gPCZy";